import { Box, Stack, styled } from '@mui/material';

export const MainContainer = styled(Box)({
  padding: '5px 20px 20px 20px',
});

export const HeadingCnt = styled('div')({
  '& .title': {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: '100%',
  },
});

export const TemplateIconAndNameCnt = styled('div')(() => ({
  display: 'flex',
  gap: 12,
  alignItems: 'center',
  padding: 10,
  cursor: 'pointer',
  justifyContent: 'space-between',
  '& .name': {
    fontWeight: 600,
    fontSize: 14,
    color: 'rgba(33, 33, 33, 1)',
    lineHeight: '143%',
    letterSpacing: '0.17px',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  '& .checkIcon': {
    color: 'rgba(104, 104, 254, 1)',
  },
}));

export const IconContainer = styled('div', {
  shouldForwardProp: (prop) => !['bgcolor'].includes(prop),
})(({ bgcolor }) => ({
  minWidth: 30,
  minHeight: 30,
  borderRadius: '4px',
  backgroundColor: bgcolor,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const LoaderCnt = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 170,
  height: '100%',
  width: '100%',
});

export const MainFooterCnt = styled(Stack)({
  padding: '15px 20px',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  borderTop: '1px solid #80808029',
  '& .selectedBtn': {
    borderRadius: 10,
  },
});

export const TemplatesCnt = styled(Box)({
  overflowY: 'auto',
  height: 400,
});
